module.exports = __webpack_public_path__ + "media/promo/hochland/images/p2-45342d0b75d6bfcb10020aa22c02410b.png";